import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import DateOfBirthForm from "@/features/profile/components/DateOfBirthForm";
import { ProfileAttributePage, useProfileAttributePage } from "@/features/profile/components/ProfileAttributePage";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

const DateOfBirth = () => {
    const { auth, copy, goToProfile } = useProfileAttributePage();
    const { data: profile } = useSuspenseQuery(selectProfileByIdQueryOptions(auth.id));

    return (
        <ProfileAttributePage
            title={copy.onboardingDateOfBirthTitle}
            description={copy.onboardingDateOfBirthDescription}
        >
            <DateOfBirthForm
                userId={auth.id}
                dateOfBirth={profile.date_of_birth}
                onBack={goToProfile}
                onSuccess={goToProfile}
                primaryLabel={copy.save}
            />
        </ProfileAttributePage>
    );
};

export const Route = createFileRoute("/_app/profile/date-of-birth")({
    component: DateOfBirth,
});
